/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CreateTenantRequest {
    getFixupPrototypeFunction() { return CreateTenantRequest.fixupPrototype; }

    static newInstance(model: Partial<CreateTenantRequest>): CreateTenantRequest {
        let obj = Object.assign(new CreateTenantRequest(), model);
        CreateTenantRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CreateTenantRequest>): CreateTenantRequest {
        if (!model) return null;
        return CreateTenantRequest.newInstance(<CreateTenantRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CreateTenantRequest) {
        if (!obj) return;

        models.CreateTenantRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CreateTenantRequest): boolean {
        Object.setPrototypeOf(obj, CreateTenantRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.activity_queue_notifications) {
            models.ActivityQueueNotificationDetails.fixupPrototype(this.activity_queue_notifications);
        }
        if (this.email_notify) {
            models.EmailNotifyConfiguration.fixupPrototype(this.email_notify);
        }
        if (this.configuration_management) {
            models.TenantConfigurationManagementOptions.fixupPrototype(this.configuration_management);
        }
    }

    /**
     * Name of the new tenant to be created. Tenant Name must be globally unique within CoreStack. If the same tenant name is used in another account, creation wil fail. Tenant Name must start with alphabet and can contain 2-50 characters. Special characters ' \" # ? / \\ are not allowed.
     */
    name: string;

    /**
     * Description of the new tenant to be created.
     */
    description: string;

    /**
     * metadata is a freeform JSON. It allows to store custom keys and values. It will be useful for storing information about an external applications that will refer to CoreStack tenant.
     */
    metadata: any;

    /**
     * Id of the CoreStack account under which the new tenant to be created.
     */
    account_id: string;

    activity_queue_notifications: models.ActivityQueueNotificationDetails;

    /**
     * Email notification configuration
     */
    email_notify: models.EmailNotifyConfiguration;

    configuration_management: models.TenantConfigurationManagementOptions;

}
